import React, { FC } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Navigate, Outlet } from 'react-router-dom';

import { isLoggedInVar } from 'graphql/cache';

import { LoginSources } from 'types/enums';

const AuthNotRequired: FC = () => {
  const source = new URLSearchParams(window.location.search).get('source');

  const isLoggedIn = useReactiveVar(isLoggedInVar);

  if (source === LoginSources.zapier) {
    return <Outlet />;
  }

  return isLoggedIn ? <Navigate to="/events/upcoming" /> : <Outlet />;
};

export default AuthNotRequired;
